@if (formGroup) {
  <div [formGroup]="formGroup">
    <div class="flex flex-col justify-between items-start w-full">
      <div class="flex flex-row gap-2 w-full">
        <div class="flex flex-row justify-between w-full gap-12">
          <div class="flex flex-col w-[50%]">
            <bic-input #street (valueChange)="addressChanged(street.value)" [bicDropdownTrigger]="dropdown" [errorCondition]="formGroup.get(formControlNameStreet)?.touched && formGroup.get(formControlNameStreet)?.invalid" [formControlName]="formControlNameStreet"
                       [label]="'Straße *'" [required]="true" [placeholder]="'Straße eingeben'" [showX]="false" class="w-full">
            </bic-input>
            <bic-dropdown #dropdown [widthOfTriggerElement]="true" dropdownPlacement="bottom-start">
              @for (location of locationGuess; track location) {
                <bic-dropdown-element (onClick)="updateLocation(location)" [value]="location.street">
                  {{ location.street }} {{ location.addressNumber }}
                  , {{ location.postalCode }} {{ location.municipality }}
                </bic-dropdown-element>
              }
            </bic-dropdown>
            <div class="flex flex-row w-full gap-12 pt-5">
              @if (!zipCodeDisabled) {
                <div class="flex flex-col w-[50%]">
                  <bic-input [errorCondition]="formGroup.get(formControlNameZipCode)?.touched && formGroup.get(formControlNameZipCode)?.invalid" [formControlName]="formControlNameZipCode" [label]="'Postleitzahl *'" [required]="true" [placeholder]="'Postleitzahl eingeben'" [showX]="false"
                             class="w-full"></bic-input>
                  @if (hasError(formControlNameZipCode, 'zipCode')) {
                    <p class="text-red-500 text-xs mt-1">{{ formGroup.get(formControlNameCountry)?.value === 'DEU' ? 'Die Postleitzahl muss aus 5 Ziffern bestehen.' : 'Bitte eine gültige Postleitzahl eingeben.' }}</p>
                  }
                </div>
              }
              @if (!cityDisabled) {
                <bic-input [errorCondition]="formGroup.get(formControlNameCity)?.touched && formGroup.get(formControlNameCity)?.invalid"  [formControlName]="formControlNameCity" [label]="'Ort *'" [required]="true" [placeholder]="'Ort eingeben'" [showX]="false"
                           class="w-[50%]"></bic-input>
              }
            </div>
          </div>
          <div class="flex flex-col w-[50%] gap-5">
            <div class="flex flex-row gap-12 w-full">
              <bic-input [errorCondition]="formGroup.get(formControlNameHouseNumber)?.touched && formGroup.get(formControlNameHouseNumber)?.invalid" [formControlName]="formControlNameHouseNumber" [label]="'Hausnummer *'" [required]="true" [placeholder]="'Hausnummer eingeben'" [showX]="false"
                         class="w-full"></bic-input>
              @if (displayPlotNumber) {
                <bic-input [formControlName]="formControlNamePlotNumber" [label]="'Flurstücksnummer'" [placeholder]="'Flurstücksnummer eingeben'" [showX]="false"
                           class="w-full"></bic-input>
              }
            </div>
            <div class="flex flex-row gap-16 w-full">
              @if (!countryDisabled) {
                @if (isCountrySelectDisabled()) {
                  <bic-input [label]="'Land *'" [value]="getCountryLabel()" [disabled]="true" [showX]="false" class="w-full"></bic-input>
                } @else {
                  <bic-select [formControlName]="formControlNameCountry" [label]="'Land *'" [placeholder]="'Land auswählen'" [required]="true" class="w-full">
                    <!-- Suche in der Liste wie im MyCheck-Testlauf: sitzt im Dropdown, bleibt beim Scrollen oben.
                         Klicks und Tasten bleiben hier, damit sie das Dropdown weder schließen noch steuern. -->
                    <div (click)="$event.stopPropagation()"
                         class="sticky top-0 z-10 flex items-center gap-2 border-b border-gray-200 bg-white px-4">
                      <fa-icon [icon]="faMagnifyingGlass" class="text-svg-16 text-gray-400"></fa-icon>
                      <input (input)="onCountrySearch($any($event.target).value)" (keydown)="$event.stopPropagation()" [value]="countrySearch"
                             aria-label="Land suchen" autocomplete="off"
                             class="w-full border-0 bg-transparent px-0 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-0"
                             placeholder="Land suchen …" type="text">
                    </div>
                    @for (country of visibleCountries.priority; track country.key) {
                      <bic-dropdown-element [value]="country.key">{{ country.label }}</bic-dropdown-element>
                    }
                    @if (showCountrySeparator) {
                      <div class="my-1 border-t border-gray-200" role="separator"></div>
                    }
                    @for (country of visibleCountries.rest; track country.key) {
                      <bic-dropdown-element [value]="country.key">{{ country.label }}</bic-dropdown-element>
                    }
                    @if (countrySearchEmpty) {
                      <p class="px-4 py-2 text-sm text-gray-500">Kein Land gefunden</p>
                    }
                  </bic-select>
                }
              }
              @if (shouldDisplayState()) {
                <div class="flex flex-col w-full">
                  <bic-select [formControlName]="formControlNameState" [label]="'Bundesland *'" [required]="true" [placeholder]="'Bundesland auswählen'"
                              class="w-full">
                    @for (state of states | keyvalue; track state) {
                      <bic-dropdown-element [value]="state.value">
                        {{ state.value | projectState }}
                      </bic-dropdown-element>
                    }
                  </bic-select>
                  @if (hasError(formControlNameState, 'required')) {
                    <p class="text-red-500 text-xs mt-1">Bitte ein Bundesland auswählen.</p>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
}
